import { ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BookingService } from '@app/listing/services/booking.service';
import SiteVisitViewModel from '@app/models/site-visit-view-model';
import {
  DateService,
  ErrorHelperService,
  MembershipService,
  NotificationService,
  ReservationService,
  UserService,
  WorkflowService,
} from '@app/services';

import { SiteVisitService } from '../../../../services/site-visit.service';
import { DatePipe } from '@angular/common';

/**
 * The actual booking request  API request is made in the SiteVisitBookComponent
 */
@Component({
    selector: "confirm-site-visit",
    templateUrl: "./confirm-site-visit.component.html",
    styleUrls: ["./confirm-site-visit.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatePipe]
})
export class ConfirmSiteVisitComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'ConfirmSiteVisitComponent';
  private _confirmEnabled: boolean;
  private workflowName = 'ScheduleOnly Booking Workflow';
  private workflowStepName = 'confirm';

  public loading = false;
  public submitting = false;
  public errorMessage: string;
  public siteVisit: SiteVisitViewModel;

  constructor(
    readonly route: ActivatedRoute,
    readonly changeDetectorRef: ChangeDetectorRef,
    readonly bookingService: BookingService,
    readonly membershipService: MembershipService,
    readonly reservationService: ReservationService,
    readonly userService: UserService,
    private dateService: DateService,
    private errorHelper: ErrorHelperService,
    private notify: NotificationService,
    private siteVisitService: SiteVisitService,
    private workflowService: WorkflowService
  ) {}

  ngOnInit() {
    this.siteVisitService.siteVisit.subscribe(
      (model) => {
        console.log(`${this._componentName} subscription model=`, model);

        this.siteVisit = model;
      },
      (err) => {
        console.error(err);
        
        this.notify.error('A subscription error occured', null);
      }
    );
  }

  /**
   * Called once, before the instance is destroyed.
   */
  ngOnDestroy(): void {}

  public get confirmEnabled(): boolean {
    if (!this.siteVisit || this.submitting) {
      return false;
    } else {
      return true;
    }
  }

  public confirmBooking() {
    console.log(`${this._componentName}.confirmBooking`);

    this.submitting = true;

    this.workflowService.stepIsReadyToBeMarkedCompleted(this.workflowName, this.workflowStepName);

    this.loading = true;
  }
}
